import { useEffect, useState } from "react";
import { fetchWithToken } from "../api/fetch";

/**
 * Hook para obtener datos de la API
 *
 * @param {string} endpoint - Endpoint de la API
 * @param {object} payload - Payload de la petición
 * @param {string} method - Método de la petición
 * @returns {object} Objeto con la información de la petición
 */
export const useGetDta = (endpoint, payload = {}, method = "GET") => {
  const [loading, setLoading] = useState(true); // Estado de carga
  const [data, setData] = useState([]); // Estado de la información

  // Obtiene la información de la API
  useEffect(() => {
    getInfo();
  }, []);

  /**
   * Obtiene la información de la API
   *
   * @param {string} point - Endpoint de la API
   * @param {object} pay - Payload de la petición
   * @param {string} met - Método de la petición
   * @returns {void}
   */
  const getInfo = async (point = endpoint, pay = payload, met = method) => {
    const resp = await fetchWithToken(point, pay, met);

    if (resp.ok) {
      const { data } = resp;
      setData(data);
      setLoading(false);
    }
  };

  return { loading, data, getInfo };
};
